import { HumanMaleBoyIcon } from './HumanMaleBoyIcon';

/**
 * author: Henrique César Madeira
 * id 07AB2970-AE77-417B-BEB3-8B6FDEF43EDE
 * name human-male-boy
 * version: 2.6.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/human-male-boy.svg
 * tags
 * - People / Family 
 */
export const FatherIcon = HumanMaleBoyIcon;
export default FatherIcon